import moment from 'moment';

import { formatTime } from '../../../utils/formatDate';
import { TIME } from '../../../configs/dateFieldSubTypes';

const DATE_FORMAT = 'DD.MM.YY';

const isWithTime = (field) => !!field && field.getIn(['config', 'type']) === TIME;

export const formatDate = (date) => (date ? moment(date).format(DATE_FORMAT) : '');

export const formatTaskTime = (date, field) => (date && isWithTime(field) ? formatTime(date) : '');

export const toDayStart = (date, field) => (isWithTime(field) ? date : moment(date).startOf('day').toDate());
export const toDayEnd = (date, field) =>
  isWithTime(field) ? date : moment(date).startOf('day').add(1, 'day').toDate();
